// extracted by mini-css-extract-plugin
export default {"editRole":"VY2voKG1J5KYXLKIXPAN"};